import { render } from "./ModalCard.vue?vue&type=template&id=c518992e"
import script from "./ModalCard.vue?vue&type=script&lang=js"
export * from "./ModalCard.vue?vue&type=script&lang=js"

import "./ModalCard.vue?vue&type=style&index=0&id=c518992e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__